/** Classify dashboard compliance-deadline reminders for distinct styling. */
export function complianceDeadlineReminderKind(text) {
  const t = String(text ?? "").trim();
  if (/listing\s*#\s*\d+\s+compliance deadline/i.test(t)) return "listing";
  if (/trade\s*#\s*.+\s+compliance deadline/i.test(t)) return "trade";
  return null;
}

export function isComplianceDeadlineReminder(text) {
  return complianceDeadlineReminderKind(text) !== null;
}

export const COMPLIANCE_REMINDER_STYLES = {
  listing: {
    card: "bg-violet-100 border-l-4 border-violet-600",
    row: "bg-violet-50 hover:bg-violet-100",
    title: "text-violet-950",
    badge: "bg-violet-200 text-violet-900 px-1.5 py-0.5 rounded",
    body: "text-violet-900",
    label: "Listing compliance",
  },
  trade: {
    card: "bg-sky-100 border-l-4 border-sky-600",
    row: "bg-sky-50 hover:bg-sky-100",
    title: "text-sky-950",
    badge: "bg-sky-200 text-sky-900 px-1.5 py-0.5 rounded",
    body: "text-sky-900",
    label: "Trade compliance",
  },
};

export function complianceReminderStyle(kind) {
  if (kind === "listing" || kind === "trade") {
    return COMPLIANCE_REMINDER_STYLES[kind];
  }
  return null;
}
